import type { CarePlan } from '@lmc/ts-common'
import type React from 'react'
import CarePlanNextReviewField from '../../../components/carePlans/CarePlanNextReviewField'

type SetFormField = {
  key: string
  value: string | number | string[] | boolean
}

interface ICarePlanReviewNextReview {
  setFormField: (update: SetFormField) => void
  fields: CarePlan
  FORM_ID: string
}

export const CarePlanReviewNextReview = ({
  setFormField,
  fields,
  FORM_ID
}: ICarePlanReviewNextReview): React.ReactElement => (
  <CarePlanNextReviewField
    fields={fields}
    formId={FORM_ID}
    setFormField={setFormField}
  />
)

export default CarePlanReviewNextReview
